import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import CustomerIndex from './CustomerIndex';
import { storeWithExpiration } from '../../utils/common';
import { getInstalls } from '../../actions/customerPortal';

export class CustomerIndexContainer extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    installations: PropTypes.object.isRequired,
    getInstallsAction: PropTypes.func.isRequired,
  };

  componentWillMount = () => {
    const { getInstallsAction } = this.props;
    const token = storeWithExpiration.get('token');
    getInstallsAction(token);
  };

  render() {
    const { account, installations } = this.props;
    return installations ? <CustomerIndex account={account} installations={installations} /> : null;
  }
}

function mapStateToProps(state) {
  const { customerPortalData, account } = state;
  const installations = customerPortalData.get('installations') || {};
  return {
    installations,
    account,
  };
}

export default connect(mapStateToProps, {
  getInstallsAction: getInstalls,
})(CustomerIndexContainer);
